// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as RegionListLine$PrezzeeRibbon from "./RegionListLine.bs.js";

var listWrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(12)),
      BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(12)),
      BsCssJs$PrezzeeRibbon.cursor("pointer"),
      BsCssJs$PrezzeeRibbon.nthChild({
            NAME: "add",
            VAL: [
              1,
              2
            ]
          }, [
            BsCssJs$PrezzeeRibbon.borderTopWidth(BsCssJs$PrezzeeRibbon.px(1)),
            BsCssJs$PrezzeeRibbon.borderTopColor(Theme__Color$PrezzeeRibbon.Personal.paleDivider),
            BsCssJs$PrezzeeRibbon.borderTopStyle("solid")
          ])
    ]);

var Styles = {
  listWrapper: listWrapper
};

function RegionList(props) {
  var onChange = props.onChange;
  var selected = props.selected;
  var selected$1 = selected !== undefined ? selected : 0;
  var onChange$1 = onChange !== undefined ? onChange : (function (param) {
        
      });
  var regionLines = Belt_Array.mapWithIndex(props.regions, (function (i, region) {
          return JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(RegionListLine$PrezzeeRibbon.make, {
                            region: region,
                            selected: selected$1 === i
                          }),
                      className: listWrapper,
                      onClick: (function (param) {
                          Curry._1(onChange$1, i);
                        })
                    }, String(i));
        }));
  return JsxRuntime.jsx("div", {
              children: regionLines
            });
}

var make = RegionList;

export {
  Styles ,
  make ,
}
/* listWrapper Not a pure module */
